/**
 * class entity for message error import file
 */
export class MessageErrorImportFile {
  /**
   * formatErrorFile
   */
  formatErrorFile: Array<String>;

  /**
   * specialCharError
   */
  specialCharError: Array<String>;

  /**
   * maxLengthError
   */
  isMaxLengthError: boolean;

  /**
   * otherError
   */
  otherError: Array<String>;

  /**
   * isValid
   */

  isValid: boolean;

  constructor(
    formatErrorFile?: Array<String>,
    specialCharError?: Array<String>,
    isMaxLengthError?: boolean,
    otherError?: Array<String>,
    isValid?: boolean
  ) {
    this.formatErrorFile = formatErrorFile;
    this.specialCharError = specialCharError;
    this.isMaxLengthError = isMaxLengthError;
    this.otherError = otherError;
    this.isValid = isValid;
  }
}
